import { render } from "./ZimbabweChaperContent.vue?vue&type=template&id=4a316f73&ts=true"
import script from "./ZimbabweChaperContent.vue?vue&type=script&lang=ts"
export * from "./ZimbabweChaperContent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__